export const COLUMNS = [
  { id: 'name', label: 'Товар', minWidth: 450 },
  { id: 'phone', label: 'Телефон', minWidth: 100 },
  { id: 'email', label: 'Почта', minWidth: 100 },
  { id: 'date', label: 'Дата', minWidth: 100 },
  {
    id: 'population',
    label: 'Действия',
    minWidth: 50,
  },
];
